import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  quote: string;
  author: string;
  location: string;
  headline?: string;
  avatarUrl?: string;
}
export function TestimonialCard({
  quote,
  author,
  location,
  headline,
  avatarUrl
}: TestimonialCardProps) {
  return <div className="bg-[#1F3A2A]/5 p-6 rounded-xl border border-[#1F3A2A]/10 shadow-sm my-6" data-id="element-58">
      <div className="flex gap-1 text-yellow-400 mb-3" data-id="element-59">
        {[...Array(5)].map((_, i) => <Star key={i} size={16} fill="currentColor" data-id="element-60" />)}
      </div>
      {headline && <h4 className="font-sans font-bold text-slate-900 text-lg mb-2" data-id="element-61">
          "{headline}"
        </h4>}
      <blockquote className="font-serif text-slate-700 italic leading-relaxed mb-4" data-id="element-62">
        "{quote}"
      </blockquote>
      <div className="flex items-center gap-3" data-id="element-63">
        {avatarUrl ? <img src={avatarUrl} alt={author} className="w-12 h-12 rounded-full object-cover border-2 border-[#1F3A2A]/20" data-id="element-64" /> : <div className="w-12 h-12 rounded-full bg-[#1F3A2A]/10 flex items-center justify-center text-[#1F3A2A] font-bold text-sm border-2 border-[#1F3A2A]/20" data-id="element-65">
            {author.charAt(0)}
          </div>}
        <div className="text-sm" data-id="element-66">
          <span className="font-bold text-slate-900 block" data-id="element-67">{author}</span>
          <span className="text-slate-500" data-id="element-68">{location}</span>
        </div>
      </div>
    </div>;
}